import React, {useContext} from 'react';
import {Table} from "antd";
import {UserContext} from "@context/UserContext";

const AccountSettingsSubscriptions = props => {
    const {userDetails} = props;
    const {user} = useContext(UserContext);

    const subscriptionsData = userDetails?.products.map((product, index) => {
        return {
            key: product.productId,
            subscription: product.name + (product.publishState.name == 'UNPUBLISHED' ? ' (in development)' : ''),
            expires: user.dateFormat.format(product.endDate) + (product.activationPending ? ' * requires activation' : '')
        }
    });
    const columns = [
        {
            title: 'Subscription',
            dataIndex: 'subscription',
            key: 'subscription',
        },
        {
            title: 'Expires',
            dataIndex: 'expires',
            key: 'expires',
        },
    ];

    return (
        <div>
            <h3>Subscriptions</h3>
            {userDetails?.products.length > 0 ? (
                <Table
                    dataSource={subscriptionsData}
                    columns={columns}
                    rowClassName={(record) => {
                        const product = userDetails?.products.find(product => product.productId === record.key);
                        if (!product) return '';
                        const now = Date.now();
                        const expiringSoonWindow = 30 * 24 * 60 * 60 * 1000;
                        const expiresSoon = product.endDate - expiringSoonWindow <= now;
                        return expiresSoon ? 'ch-alert-warning' : '';
                    }}
                />
            ) : (
                <p>You have no current products</p>
            )}
        </div>
    )
}

export default AccountSettingsSubscriptions;